// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"b0d44b08","200":"1c9e0949","374":"91b8bf90","453":"d5669736","635":"2ffaac0c"}[chunkId] + ".chunk.js";
};